import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import UploadDropzone from "./UploadDropzone";
import DocumentList from "./DocumentList";

const useStyles = makeStyles(() => ({
  zone: {
    marginTop: 35
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
}));

const Attachments = ({
  addAttachments,
  deleteAttachment,
  attachments,
  getAttachments,
  title, editmode, personId
}) => {
  const classes = useStyles();

  React.useEffect(() => {
    getAttachments();
  }, []);

  return <div className={classes.zone}>
          <Typography className={classes.heading}>{title}</Typography>
          <div>
            {(attachments && attachments.length > 0) ?
              <DocumentList files={attachments}
                            deleteAttach={deleteAttachment}/>
              : <Typography color={"textSecondary"}>файлы отсутствуют</Typography>
            }
          </div>
          <div className={classes.zone}>
            <UploadDropzone onDrop={addAttachments} />
          </div>
        </div>
};

export default Attachments;
